import React from 'react';
import PropTypes from 'prop-types';
import { pick } from 'lodash';
import { Line, Svg, Polygon } from '@dbk/ui-svg';
import { View } from '@dbk/ui-react-utils';
import { propTypes, contextTypes, privateOrientationType } from '../common';
import {
  calculateInlineStyle,
  arrowPoints,
  getFillColor,
  getStrokeColor,
} from './arrow.styles';

const getLineProps = (points, stroke) => ({
  x1: points[0],
  y1: points[1],
  x2: points[2],
  y2: points[3],
  stroke,
});

const Arrow = ({ orientation, position, bottomEdge, type, arrowColor }, { inverse }) => {
  const points = arrowPoints[orientation] || [];
  if (!bottomEdge) {
    return null;
  }
  const fillColor = getFillColor(inverse, type, arrowColor);
  const strokeColor = getStrokeColor(inverse, type, arrowColor);
  return (
    <View
      className="arrow"
      style={calculateInlineStyle(orientation, position, bottomEdge)}
    >
      <Svg
        fill={fillColor}
        stroke={fillColor}
        strokeWidth={2}
        shapeRendering="crispEdges"
      >
        <Polygon points={points} />
        <Line {...getLineProps(points.slice(0, 4), strokeColor)} />
        <Line {...getLineProps(points.slice(2, 6), strokeColor)} />
      </Svg>
    </View>
  );
};

Arrow.propTypes = {
  type: PropTypes.string.isRequired,
  bottomEdge: PropTypes.number,
  orientation: privateOrientationType,
  ...pick(propTypes, ['position']),
};

Arrow.defaultProps = {
  bottomEdge: undefined,
  orientation: '',
};

Arrow.contextTypes = contextTypes;

export default Arrow;
